'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateFieldRest = function () {
  function DateFieldRest($http) {
    (0, _classCallCheck3.default)(this, DateFieldRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      FIELDS_LIST: 'date-fields/',
      FIELDS_DETAIL: 'date-fields/%1$s/'
    };
  }

  (0, _createClass3.default)(DateFieldRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.FIELDS_LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.FIELDS_DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.FIELDS_LIST, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.FIELDS_DETAIL, id));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete(this.sprintf(this.PATH.FIELDS_DETAIL, id));
    }
  }, {
    key: 'findFieldByPath',
    value: function findFieldByPath(fields, name) {
      for (var i in fields) {
        var path = fields[i].path === "" ? fields[i].slug : fields[i].path + "." + fields[i].slug;
        if (path == name) {
          return i;
        }
      }
      return -1;
    }
  }]);
  return DateFieldRest;
}();

exports.default = DateFieldRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/DateFieldResource.js
// module id = 311
// module chunks = 0